import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Switch } from '@headlessui/react';
import React from 'react';

import type { Props } from './types';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Toggle = ({
  enabled,
  disableInput = false,
  onChange,
  label,
  subLabel,
  enabledIcon,
  disabledIcon,
  primaryColor = 'green'
}: Props) => {
  const disabledClassNames = 'opacity-50 cursor-not-allowed';

  return (
    <Switch.Group as="div" className={`flex items-center ${disableInput && disabledClassNames}`}>
      <Switch
        checked={enabled}
        disabled={disableInput}
        onChange={onChange}
        className={classNames(
          enabled ? `bg-${primaryColor}-600` : 'bg-gray-200',
          'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-green-600 focus:ring-offset-2'
        )}>
        <span className="sr-only">{label}</span>
        <span
          className={classNames(
            enabled ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'
          )}>
          {enabledIcon && (
            <span
              className={classNames(
                enabled
                  ? 'text-green-600 opacity-100 duration-200 ease-in'
                  : 'opacity-0 duration-100 ease-out',
                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
              )}
              aria-hidden="true">
              <FontAwesomeIcon icon={enabledIcon} />
            </span>
          )}
          {disabledIcon && (
            <span
              className={classNames(
                enabled
                  ? 'opacity-0 duration-100 ease-out'
                  : 'text-gray-300 opacity-100 duration-200 ease-in',
                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
              )}
              aria-hidden="true">
              <FontAwesomeIcon icon={disabledIcon} />
            </span>
          )}
        </span>
      </Switch>
      <Switch.Label as="span" className="ml-3 text-sm">
        <span className="font-medium text-gray-900">{label}</span>{' '}
        {subLabel && <span className="text-gray-500">({subLabel})</span>}
      </Switch.Label>
    </Switch.Group>
  );
};
export default React.memo(Toggle);
